import React, { useState } from "react";
import EmailSignUp from "../emailSignUp";
import FooterMenu from "./footerMenu";
import Payments from "./paymentLogos";
// import { useOptions } from "../../../hooks/useOptions";
import { useMenu } from "../../../hooks/useMenu";
import Container from "../container";
import { __t } from "../../../utils/translate";
import OtherCountries from "./otherCountries";

type FooterProps = {
    hiddenElements?: boolean;
};

const Footer: React.FC<FooterProps> = ({ hiddenElements }) => {

    let menus = [];
    ['footer_1', 'footer_2', 'footer_3'].map((location) => {
        const menu = useMenu(location);
        if (menu) {
            menus.push(<FooterMenu title={menu.name} items={menu.items} className={`${location === 'footer_1' ? '' : 'pt-10'}`} />);
        }
    });

    if (!hiddenElements) {
        menus.push(<Payments className="pt-10 pb-1 md:pt-0 md:pb-8" />);
        menus.push(<></>); // <SignUpForOffers className="" />
        menus.push(<OtherCountries title={__t("Ortorex in other countries")} />);
    } else {
        menus.push(<Payments className="" />);
        menus.push(<></>);
        menus.push(<></>);
    }

    return (
        <footer className="bg-dark-blu py-10 md:py-20 font-plex">
            <Container>
                <MenuGrid
                    items={menus}
                />
                {/* <p className="text-base-16 text-footer-text-color mt-10 sm:mt-14">{`©2022-${new Date().getFullYear()}_Ortorex`}</p> */}
            </Container>
        </footer>
    );
};

export type WithClassName = {
    className?: string;
}

type MenuGridType = WithClassName & {
    items;
};

const MenuGrid: React.FC<MenuGridType> = ({
    className = "",
    items,
}) => {
    return (
        <div className="flex gap-8 md:px-3 xl:px-[50px] justify-center">
            <div className="md:hidden">{items.map((item, key) => <div key={key + 100}>{item}</div>)}</div>

            <div className="hidden md:flex gap-4 lg:gap-[24px] xl:gap-12 w-full whitespace-normal">
                <div className="flex-auto md:w-[22%]">
                    {items[0]}<div className="md:hidden">{items[1]}</div>
                </div>
                <div className="flex-col flex-auto hidden md:flex md:w-[22%]">
                    {items[1]}
                </div>
                <div className="flex-auto hidden md:flex md:w-[22%]">
                    {items[2]}
                </div>
                <div className="flex-auto md:w-[22%]">
                    <div className="flex-auto md:hidden flex">{items[2]}</div>
                    {items[3]}{items[4]}{items[5]}
                </div>
            </div>
        </div>
    );
};

const SignUpForOffers: React.FC<WithClassName> = ({ className = "" }) => {
    return (
        <div className={`${className} py-5 border-b border-stroke-color md:border-none border-opacity-20 text-center md:text-left`}>
            <p className="text-base-16 text-white uppercase mb-[10px] font-bold">
                {__t("Sign Up For Exclusive Offers")}
            </p>
            <div className={`flex flex-col`}>
                <EmailSignUp />
            </div>
        </div>
    );
};

export default Footer;
